"use strict";

var Logger = require("js-logger");

Logger.useDefaults({
	defaultLevel: Logger.ERROR
});

module.exports = {
	ContactUsActions: require("../actions/ContactUsActions"),
	ContactUsStore: require("../stores/ContactUsStore"),
	CommunicationTypeSelector: require("./CommunicationTypeSelector")
};